var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUncheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 7.36838,
    cy: 7.84208,
    r: 6.85434,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36842 1.50185C3.86679 1.50185 1.02815 4.34048 1.02815 7.84211C1.02815 11.3437 3.86679 14.1824 7.36842 14.1824C10.8701 14.1824 13.7087 11.3437 13.7087 7.84211C13.7087 4.34048 10.8701 1.50185 7.36842 1.50185ZM0 7.84211C0 3.77265 3.29895 0.473694 7.36842 0.473694C11.4379 0.473694 14.7368 3.77265 14.7368 7.84211C14.7368 11.9116 11.4379 15.2105 7.36842 15.2105C3.29895 15.2105 0 11.9116 0 7.84211Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedIcon);
export default __webpack_public_path__ + "static/media/unchecked-icon.02447c92b4978bc5b16f109a0cf6cb14.svg";
export { ForwardRef as ReactComponent };